import React, { useState } from "react";
import Sidebar from "./AdminComp/Sidebar";
import BreadCrumb from "./AdminComp/BreadCrumb";
import Swal from "sweetalert2";
import { baseurl } from "../../component/Baseurl";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import icons for eye functionality

function AdminPasswordChange() {
  const adminId = localStorage.getItem("adminId");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // To toggle password visibility
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // To toggle confirm password visibility

  // Toggle password visibility
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);

  const handlePasswordChange = async (e) => {
    e.preventDefault(); // Prevent form submission

    // Check if passwords match
    if (newPassword !== confirmPassword) {
      console.log("Passwords do not match"); // Logging for debugging
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Passwords do not match. Please enter the correct password.",
      });
      return; // Prevent form submission
    }

    const payload = {
      id: adminId,
      newPassword: newPassword,
    };

    // Log the payload being sent
    console.log("Sent data:", payload);

    try {
      const response = await fetch(`${baseurl}/update-admin-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      // Log the API response
      console.log("API Response:", data);

      // Check the message in the response and display the relevant Swal alert
      if (response.ok && data.message === "Password updated successfully") {
        Swal.fire({
          icon: "success",
          title: "Password Updated!",
          text: data.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Network error, please try again later.",
      });
      // Log the error
      console.error("Error:", error);
    }
  };

  // Check if passwords match to control the visibility of the button
  const isPasswordsMatch = newPassword === confirmPassword;

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />
        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              <div className="crdmain mb-2">
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{ width: "100%" }}
                >
                  <h2 className="chart-title mb-0">Change Password</h2>
                  <div className="ms-auto"></div>
                </div>

                <div className="row g-2 mt-0 mb-0">
                  <div className="col-md-12 p-2">
                    {/* Change Password Form */}
                    <form onSubmit={handlePasswordChange}>
                      <div className="row g-1 text-start">
                        <div className="col-md-9 ">
                          <div className="row g-1">
                            {/* Password */}
                            <div className="col-md-12">
                              <label className="text-dark mb-1 labelset2 font3">
                                Password
                              </label>
                              <div className="input-group">
                                <input
                                  type={showPassword ? "text" : "password"}
                                  className="input1 w-75"
                                  placeholder="Enter New Password"
                                  value={newPassword}
                                  onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <span 
                                  className="smm1"
                                  onClick={togglePasswordVisibility}
                                >
                                  {showPassword ? "Hide Password" : "Show Password"}
                                </span>
                              </div>
                            </div>

                            {/* Confirm Password */}
                            <div className="col-md-12">
                              <label className="text-dark mb-1 labelset2 font3">
                                Confirm Password
                              </label>
                              <div className="input-group">
                                <input
                                  type={showConfirmPassword ? "text" : "password"}
                                  className="input1 w-75"
                                  placeholder="Confirm New Password"
                                  value={confirmPassword}
                                  onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                                <span 
                                  className="smm1"
                                  onClick={toggleConfirmPasswordVisibility}
                                >
                                  {showConfirmPassword ? "Hide Password" : "Show Password"}
                                </span>
                              </div>
                            </div>
                          </div>
                          {/* Submit Button */}
                          {isPasswordsMatch && (
                            <div className="text-end">
                              <button
                                type="submit"
                                className="submit-btn mt-3"
                              >
                                Save Changes
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminPasswordChange;
